export default __webpack_public_path__ + "static/media/gallery_02.9f25cd81.jpg";